import { Flex, Text } from '@chakra-ui/react'
import React from 'react'

import { useTranslations } from '../../hooks/useTranslations'
import {
  DropdownButtonDisplayProps,
  DropdownOption,
  StandardDropdown,
  StandardDropdownProps,
} from './StandardDropdown'

type SortDropdownProps = StandardDropdownProps<DropdownOption>
type SortButtonDisplayProps = DropdownButtonDisplayProps<DropdownOption>
const SortButtonDisplay: React.FC<SortButtonDisplayProps> = ({
  disabled,
  options,
  value,
}) => {
  const displayValue =
    options?.find(({ value: v }) => v === value)?.description || value || ''
  const t = useTranslations()

  return (
    <Flex color={disabled ? 'neutral.50' : 'inherit'}>
      <Text as="span" color="neutral.50" display={['none', 'inline']}>
        {t('label.sortby')}:&nbsp;
      </Text>
      {displayValue}
    </Flex>
  )
}

export const SortDropdown = (props: SortDropdownProps) => (
  <StandardDropdown displayButton={SortButtonDisplay} {...props} />
)
